// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, Input, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SystemDocument } from '@interfaces/document.interfaces';
import { ModalSize } from '@interfaces/shared.interfaces';
import { SharedService } from '@services/shared.service';
import { UserService } from '@services/user.service';
import { takeWhile } from 'rxjs';
import { SystemDocumentModalComponent } from 'src/app/modals/system-document-modal/system-document-modal.component';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnDestroy {
    @Input() hideVersion: boolean = null;

    private isComponentAlive = true;
    private systemDocs: SystemDocument[] = [];

    public versionNumber: string = null;
    public isLoading = false;
    public year = new Date().getFullYear();

    constructor(
        private readonly userService: UserService,
        private readonly dialog: MatDialog,
        private readonly sharedService: SharedService
    ) {
        this.userService
            .getVersionNumber()
            .pipe(takeWhile(() => this.isComponentAlive))
            .subscribe((version) => {
                this.versionNumber = version;
            });
    }

    public viewPrivacy(): void {
        window.open('/agreements/PrivacyPolicy', '_blank');
    }

    public viewTandC(): void {
        window.open('/agreements/EndUserAgreement', '_blank');
    }

    public viewStellantisEULA(): void {
        window.open('/agreements/StellantisEULA', '_blank');
    }

    //Keeping this around in case of usage in the future
    private async getSystemDocuments(type: number): Promise<void> {
        //Load documents only when trying to view documents and only once.
        if (this.systemDocs.length === 0) {
            this.userService
                .getHelpPageSystemDocuments()
                .pipe(takeWhile(() => this.isComponentAlive))
                .subscribe((docs) => {
                    this.systemDocs = docs;
                    this.openModal(type);
                });
        } else {
            this.openModal(type);
        }
    }

    private openModal(docType: number): void {
        this.dialog.open(SystemDocumentModalComponent, {
            width: this.sharedService.getModalWidth(ModalSize.Large) + 'px',
            height: this.sharedService.getModalHeight(ModalSize.Large) + 'px',
            closeOnNavigation: false,
            data: {
                modalSize: ModalSize.Large,
                doc: this.systemDocs[docType],
            },
        });
    }

    public viewDocument(type: number): void {
        this.getSystemDocuments(type);
    }

    ngOnDestroy(): void {
        this.isComponentAlive = false;
    }
}
